import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, MotionConfig, motion } from 'framer-motion';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useState } from 'react';
import { XPFloat } from '../../features/gamification/components/XPFloat.js';
import { LevelUpModal } from '../../features/gamification/components/LevelUpModal.js';
import { useLevelUpWatcher } from '../../features/gamification/hooks/useLevelUpWatcher.js';

export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Feedback optimista de gamificación: +XP flotante y modal al subir de nivel
  useLevelUpWatcher();

  // Immersive routes: Sidebar, Header and FAB are hidden
  const isImmersive =
    location.pathname.startsWith('/podcasts/') && location.pathname !== '/podcasts';

  if (isImmersive) {
    return (
      <div className="h-screen overflow-hidden bg-black">
        {/* reducedMotion="user" respeta prefers-reduced-motion en las transiciones de página */}
        <MotionConfig reducedMotion="user">
          <AnimatePresence mode="wait">
            <motion.main
              key={location.pathname}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="h-full"
            >
              <Outlet />
            </motion.main>
          </AnimatePresence>
        </MotionConfig>
        <XPFloat />
        <LevelUpModal />
      </div>
    );
  }

  return (
    <MotionConfig reducedMotion="user">
      <div className="flex h-screen overflow-hidden">
        <Sidebar open={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
        <div className="flex flex-1 flex-col overflow-hidden">
          <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
          <AnimatePresence mode="wait">
            <motion.main
              key={location.pathname}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15, ease: 'easeOut' as const }}
              className="flex-1 overflow-y-auto bg-[var(--color-bg)] p-6 pb-6"
            >
              <Outlet />
            </motion.main>
          </AnimatePresence>
        </div>
        <XPFloat />
        <LevelUpModal />
      </div>
    </MotionConfig>
  );
}
